import ErrorFilledCvna from '@carvana/ds-icons/ErrorFilledCvna';
import { useContext, useEffect } from 'react';
import ErrorContext from '~/context/srp/ErrorContext';
import useReplaceToast from '~/hooks/common/ui/useReplaceToast';

export default function NativeError() {
  const replaceToast = useReplaceToast();
  const { nativeError } = useContext(ErrorContext);

  useEffect(() => {
    if (!nativeError) return;

    replaceToast({
      dismissal: { type: 'manual' },
      header: 'Error',
      icon: <ErrorFilledCvna />,
      subCopy: nativeError.message
    });
  }, [nativeError, replaceToast]);

  return null;
}
